module.exports = __webpack_public_path__ + "static/CEO-a9d454f656017504f139af2e873caa9f.png";